import HttpResponse from "../../../../../utils/http/http.response";

export enum ContractsCargoTaxiListResponseModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsCargoTaxiListResponseCargoCompany = {
  companyName: string;
};

export type ContractsCargoTaxiListResponseTaxiCorporation = {
  companyName: string;
};

export type ContractsCargoTaxiListResponseItem = {
  id: string;
  taxiCorporation: ContractsCargoTaxiListResponseTaxiCorporation;
  cargoCompany: ContractsCargoTaxiListResponseCargoCompany;
  publishingAllowed: boolean;
  model: ContractsCargoTaxiListResponseModel;
  validSince: Date;
  validTo: Date;
  isValid: boolean;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
};

type ContractsCargoTaxiListResponse = HttpResponse<{
  data: ContractsCargoTaxiListResponseItem[];
  totalCount: number;
}>;

export default ContractsCargoTaxiListResponse;
